<template>
  <l-layout :layout="['xs12']" bottom-space>
    <l-data-table
      :get-data-func="getOrgs"
      :headers="headers"
      @click:row="goDetails($event.item)"
      clickable
      init-sort-by="name"
      ref="dataTable"
      title-text="合作单位列表"
      v-model="selected"
      search-text="搜索合作单位名称"
    >
    </l-data-table>

    <l-fixed-btn
      @click="goNew"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
  // import {time} from '../../../ladmin/utils'
  // import LActionCard from '../../../components/LActionCard'
  import defaults from '../../../consts'
  export default {
    name: 'cooperateOrganizationList',
    // components: {LActionCard},
    data: () => ({
      selected: [],
      floatingButton: false,
      moreActions: [
        {
          event: 'delete',
          label: '批量删除',
          icon: '$vuetify.icons.deleteAll'
        },
        // {
        //   event: 'bindGroup',
        //   label: '批量绑定分组类型',
        //   icon: '$vuetify.icons.group'
        // },
        // {
        //   event: 'bindRole',
        //   label: '批量绑定角色',
        //   icon: '$vuetify.icons.role'
        // },
        // {
        //   event: 'export',
        //   label: '导出PDF',
        //   icon: '$vuetify.icons.description'
        // }
      ],
      headers: defaults.userAdmin.GROUP_HEADERS,
    }),
    methods: {
      async getOrgs ({pagination, sortStack, filterItems, search}) {
        let res = await this.$store.dispatch('userAdmin/getOrgListByName', {
          pagination,
          name: search,
          id: '',
          type: 'org'
        })
        console.log(res)
        if (res.data.status === 1) {
          return {items: res.data.data.content, amount: res.data.data.totalElements}
        }
        else {
          this.$L.alert('查询单位信息失败，原因:' + res.data.msg)
        }
      },
      refresh () {
        if (this.$refs.dataTable) {
          this.$refs.dataTable.refresh()
        }
      },
      async deleteOrg (org) {
        // console.log(user)
        if (!org) return
        let {res, close} = await this.$L.confirm({
          title: '确认删除该单位？',
          text: org.name || `N/A`,
        })
        if (res) {
          try {
            await this.$store.dispatch('userAdmin/deleteGroups', [org])
            this.refresh()
            this.$L.alert('success', {message: '删除成功'})
          }
          catch (e) {
            this.$L.alert('error', {message: e.message})
          }
        }
        close()
      },
      goDetails (item, force) {
        let selectionString = document.getSelection().toString()
        if (!selectionString || force) {
          this.$router.push({
            name: 'cooperateOrganizationDetailBox',
            params: {name: item.name},
            query: {id: item.id}
          })
        }
      },
      goNew () {
        this.$router.push({
          name: 'NewOrg'
        })
      }
    }
  }
</script>

<style scoped>

</style>
